import React from 'react';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import ExtensionIcon from '@mui/icons-material/Extension';
import AppsIcon from '@mui/icons-material/Apps';
import CodeIcon from '@mui/icons-material/Code';
import DescriptionIcon from '@mui/icons-material/Description';
import WidgetsIcon from '@mui/icons-material/Widgets';
import BrushIcon from '@mui/icons-material/Brush';
import ScienceIcon from '@mui/icons-material/Science';

/**
 * Mappa categoria -> icona MUI
 */
export const CATEGORY_ICON_MAP = {
  bundle: <Inventory2Icon sx={{ fontSize: 48, color: '#7f8c8d' }} />,
  optional: <ExtensionIcon sx={{ fontSize: 48, color: '#3498db' }} />,
  appvol: <AppsIcon sx={{ fontSize: 48, color: '#9b59b6' }} />,
  development: <CodeIcon sx={{ fontSize: 48, color: '#2ecc71' }} />,
  office: <DescriptionIcon sx={{ fontSize: 48, color: '#e74c3c' }} />,
  design: <BrushIcon sx={{ fontSize: 48, color: '#e67e22' }} />,
  science: <ScienceIcon sx={{ fontSize: 48, color: '#1abc9c' }} />,
  default: <WidgetsIcon sx={{ fontSize: 48, color: '#95a5a6' }} />,
};

/**
 * Mappa categoria -> etichetta italiana per i chip
 */
export const CATEGORY_LABELS = {
  bundle: 'Bundle',
  optional: 'Opzionale',
  appvol: 'App Volumes',
  development: 'Sviluppo',
  office: 'Office',
  design: 'Design',
  science: 'Scientifico',
};

/**
 * Restituisce l'icona per un'app, con fallback alla mappa categorie.
 * Le icone AppVol sono path relativi (/snapvols/...) che non sono direttamente
 * raggiungibili dal browser, quindi usiamo il fallback MUI per ora.
 */
export function resolveIcon(app) {
  if (app.icon && app.icon.startsWith('http')) {
    return (
      <img
        src={app.icon}
        alt={app.name}
        style={{ width: 48, height: 48, objectFit: 'contain' }}
      />
    );
  }
  return CATEGORY_ICON_MAP[app.category] || CATEGORY_ICON_MAP.default;
}

/**
 * Restituisce l'etichetta localizzata per una categoria
 */
export function getCategoryLabel(category) {
  return CATEGORY_LABELS[category] || category;
}
